export default "__VITE_ASSET__BTufdURX__"